// Detailed service information for individual service pages

export const serviceDetails = {
  "company-registration": {
    title: "Company Registration Services",
    subtitle: "Choose the Right Business Structure for Your Success",
    description: "Expert guidance in selecting and registering the most suitable business entity for your entrepreneurial journey.",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&h=600&fit=crop",
    
    subServices: [
      {
        id: 1,
        name: "Private Limited Company",
        icon: "Building2",
        description: "Most popular choice for startups and growing businesses seeking funding and limited liability.",
        benefits: [
          "Separate Legal Entity - Company is distinct from its owners",
          "Limited Liability - Personal assets protected",
          "Easy to Raise Funds - Can issue shares to investors",
          "Perpetual Succession - Continues despite member changes",
          "Credibility - Higher trust among stakeholders and banks",
          "Tax Benefits - Lower corporate tax rates available"
        ],
        requirements: [
          "Minimum 2 Directors and 2 Shareholders",
          "Digital Signature Certificate (DSC)",
          "Director Identification Number (DIN)",
          "PAN and TAN",
          "Registered office address proof"
        ],
        suitableFor: "Startups seeking venture capital, businesses planning to scale, and multiple founders"
      },
      {
        id: 2,
        name: "Limited Liability Partnership (LLP)",
        icon: "Users",
        description: "Hybrid structure combining benefits of partnership and company with lower compliance burden.",
        benefits: [
          "Lower Compliance - Less stringent than Private Limited",
          "Flexibility - Partnership agreement governs operations",
          "Separate Legal Entity - Independent from partners",
          "Limited Liability - Partners' personal assets protected",
          "No Dividend Distribution Tax",
          "Easy to Manage - Simpler operational requirements"
        ],
        requirements: [
          "Minimum 2 Designated Partners",
          "DPIN for all partners",
          "LLP Agreement",
          "Registered office address"
        ],
        suitableFor: "Professional service providers, small to medium businesses, and partners wanting operational flexibility"
      },
      {
        id: 3,
        name: "One Person Company (OPC)",
        icon: "User",
        description: "Perfect for solo entrepreneurs wanting corporate structure with single ownership.",
        benefits: [
          "Single Ownership - Complete control over business",
          "Limited Liability - Personal asset protection",
          "Separate Legal Entity - Company is independent",
          "Easy Conversion - Can convert to Private Limited later",
          "Lower Compliance - Simpler than Private Limited",
          "No Minimum Capital Requirement"
        ],
        requirements: [
          "Single Director and Shareholder",
          "One Nominee (mandatory)",
          "DSC and DIN",
          "Registered office address"
        ],
        suitableFor: "Solo entrepreneurs, small businesses with single owner, and testing business ideas"
      },
      {
        id: 4,
        name: "Partnership Firm",
        icon: "Handshake",
        description: "Traditional structure for businesses owned and managed by partners for profit.",
        benefits: [
          "Easy Formation - Simple registration process",
          "Flexible Profit Sharing - As per partnership deed",
          "No Minimum Capital - Partners decide investment",
          "Shared Responsibility - Workload distributed",
          "Lower Costs - Minimal registration expenses",
          "Tax Benefits - Partners taxed individually"
        ],
        requirements: [
          "Minimum 2 Partners (Maximum 50)",
          "Partnership Deed",
          "PAN of firm and partners",
          "Address proof of firm"
        ],
        suitableFor: "Small businesses, professionals practicing together, and family businesses"
      },
      {
        id: 5,
        name: "Proprietorship",
        icon: "UserCircle",
        description: "Simplest business structure for individual entrepreneurs starting small.",
        benefits: [
          "Easiest to Start - Minimal formalities",
          "Full Control - Complete decision-making power",
          "Tax Benefits - Business income added to personal income",
          "No Compliance Burden - Minimal regulatory requirements",
          "Low Cost - Almost free registration",
          "Easy Closure - Simple to wind up"
        ],
        requirements: [
          "PAN Card of proprietor",
          "Address proof of business",
          "Bank account in business name",
          "Shop Act License (if applicable)"
        ],
        suitableFor: "Individual consultants, freelancers, and very small businesses"
      }
    ],
    
    ourServices: [
      "Name availability search and approval",
      "Document preparation and verification",
      "Government registration and filing",
      "PAN, TAN, and GST registration",
      "Bank account opening assistance",
      "Compliance calendar and advisory",
      "Post-incorporation support"
    ],
    
    process: [
      { step: 1, title: "Consultation", description: "Understand your business needs and recommend structure" },
      { step: 2, title: "Documentation", description: "Prepare and verify all required documents" },
      { step: 3, title: "Name Approval", description: "Get company name approved from ROC" },
      { step: 4, title: "Registration", description: "File incorporation documents with authorities" },
      { step: 5, title: "Certificates", description: "Receive incorporation certificate and PAN/TAN" },
      { step: 6, title: "Compliance Setup", description: "Setup compliance calendar and advisory" }
    ]
  },
  
  "gst-services": {
    title: "GST Returns and Assessment Services",
    subtitle: "Complete GST Compliance Solutions",
    description: "End-to-end GST services from registration to return filing and assessment management.",
    image: "https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=1200&h=600&fit=crop",
    
    subServices: [
      {
        id: 1,
        name: "GST Registration",
        icon: "FileCheck",
        description: "Quick and hassle-free GST registration for your business.",
        details: [
          "New GST registration within 3-5 working days",
          "Amendment of existing GST registration",
          "Cancellation and revocation support",
          "State-wise registration for multiple locations"
        ]
      },
      {
        id: 2,
        name: "GST Return Filing",
        icon: "FileText",
        description: "Timely and accurate GST return filing services.",
        details: [
          "GSTR-1: Monthly/Quarterly outward supply returns",
          "GSTR-3B: Monthly summary returns with tax payment",
          "GSTR-9: Annual returns and reconciliation",
          "GSTR-9C: Reconciliation statement certified by CA"
        ]
      },
      {
        id: 3,
        name: "Input Tax Credit (ITC) Management",
        icon: "TrendingUp",
        description: "Maximize your ITC claims and reconciliation.",
        details: [
          "ITC reconciliation with GSTR-2B",
          "Eligible ITC identification",
          "Blocked credit analysis",
          "ITC reversal computation"
        ]
      },
      {
        id: 4,
        name: "GST Assessment & Notice Handling",
        icon: "AlertCircle",
        description: "Expert representation in GST assessments and notices.",
        details: [
          "Show cause notice responses",
          "Assessment proceedings representation",
          "Refund claims and follow-up",
          "Appeal filing and representation"
        ]
      }
    ],
    
    ourServices: [
      "GST registration and amendments",
      "Monthly/Quarterly return filing",
      "Annual return and reconciliation",
      "GST advisory and planning",
      "Input tax credit optimization",
      "Assessment and litigation support",
      "GST audit assistance"
    ]
  },
  
  "income-tax-services": {
    title: "Income Tax Services",
    subtitle: "Comprehensive Tax Planning and Compliance",
    description: "Expert income tax services for individuals, businesses, and corporates with strategic tax planning.",
    image: "https://images.unsplash.com/photo-1554224154-22dec7ec8818?w=1200&h=600&fit=crop",
    
    subServices: [
      {
        id: 1,
        name: "Individual Tax Return Filing",
        icon: "User",
        description: "ITR filing for salaried, self-employed, and business individuals.",
        details: [
          "ITR-1 to ITR-7 filing based on income sources",
          "Capital gains computation and reporting",
          "Foreign income and asset disclosure",
          "Tax planning and investment advisory"
        ]
      },
      {
        id: 2,
        name: "Business Tax Return Filing",
        icon: "Building",
        description: "Corporate and business tax compliance services.",
        details: [
          "Company and LLP tax return filing",
          "Partnership and proprietorship returns",
          "Tax audit under Section 44AB",
          "Transfer pricing documentation"
        ]
      },
      {
        id: 3,
        name: "TDS Compliance",
        icon: "Receipt",
        description: "Complete TDS return filing and compliance management.",
        details: [
          "TDS return filing (24Q, 26Q, 27Q, 27EQ)",
          "TDS payment and challan verification",
          "Form 16/16A issuance",
          "Lower TDS certificate applications"
        ]
      },
      {
        id: 4,
        name: "Assessment & Appeals",
        icon: "Scale",
        description: "Expert representation in tax assessments and appeals.",
        details: [
          "Scrutiny assessment representation",
          "Notice response and compliance",
          "Appeal filing before CIT(A) and ITAT",
          "Faceless assessment support"
        ]
      }
    ],
    
    ourServices: [
      "Income tax return filing (all ITRs)",
      "Tax planning and advisory",
      "TDS compliance and filing",
      "Tax audit under Section 44AB",
      "Assessment and appeal services",
      "Refund processing and follow-up",
      "Advance tax computation"
    ]
  },
  
  "startup-consultancy": {
    title: "Startup Consultancy Services",
    subtitle: "Your Partner in Building Successful Startups",
    description: "End-to-end support for startups from ideation to scaling, including funding, compliance, and growth strategies.",
    image: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=1200&h=600&fit=crop",
    
    subServices: [
      {
        id: 1,
        name: "Business Planning & Strategy",
        icon: "Target",
        description: "Strategic business planning and market entry strategies.",
        details: [
          "Business model development",
          "Market research and analysis",
          "Competitive analysis",
          "Go-to-market strategy"
        ]
      },
      {
        id: 2,
        name: "Funding Assistance",
        icon: "DollarSign",
        description: "Support in raising funds from investors and institutions.",
        details: [
          "Financial projections and modeling",
          "Investor pitch deck preparation",
          "Valuation and term sheet negotiation",
          "Due diligence support"
        ]
      },
      {
        id: 3,
        name: "Compliance Setup",
        icon: "FileCheck",
        description: "Complete regulatory compliance framework setup.",
        details: [
          "Entity structure selection and registration",
          "All statutory registrations (PAN, TAN, GST, etc.)",
          "Founders' agreement drafting",
          "Compliance calendar setup"
        ]
      },
      {
        id: 4,
        name: "Growth Support",
        icon: "TrendingUp",
        description: "Ongoing support for scaling your startup.",
        details: [
          "Financial management and MIS",
          "Fundraising rounds support",
          "Merger and acquisition advisory",
          "Exit strategy planning"
        ]
      }
    ],
    
    ourServices: [
      "Business plan and pitch deck preparation",
      "Entity selection and incorporation",
      "Startup India registration and benefits",
      "Funding assistance and investor connect",
      "Financial planning and projections",
      "Compliance management",
      "Strategic advisory and mentorship"
    ]
  },
  
  "accounting-bookkeeping": {
    title: "Accounting & Bookkeeping Services",
    subtitle: "Professional Financial Record Management",
    description: "Comprehensive accounting and bookkeeping services to keep your financial records accurate and compliant.",
    image: "https://images.unsplash.com/photo-1554224154-22dec7ec8818?w=1200&h=600&fit=crop",
    
    ourServices: [
      "Daily transaction recording",
      "Bank reconciliation",
      "Accounts payable and receivable management",
      "Financial statements preparation",
      "MIS reporting and dashboards",
      "Payroll processing",
      "Inventory management",
      "Expense tracking and analysis"
    ]
  },
  
  "virtual-cfo": {
    title: "Virtual CFO Services",
    subtitle: "Strategic Financial Leadership for Your Business",
    description: "Experienced CFO services on demand for strategic financial planning, analysis, and decision support.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=600&fit=crop",
    
    ourServices: [
      "Financial planning and analysis",
      "Cash flow management and forecasting",
      "Budgeting and variance analysis",
      "MIS and management reporting",
      "Fundraising and investor relations",
      "Cost optimization strategies",
      "Risk management and internal controls",
      "Strategic business advisory"
    ]
  },
  
  "rera-services": {
    title: "RERA Registration and Compliance",
    subtitle: "Complete RERA Solutions for Real Estate Projects",
    description: "Expert RERA registration, compliance, and advisory services for real estate developers and agents.",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop",
    
    ourServices: [
      "Project and agent RERA registration",
      "Quarterly return filing",
      "Annual compliance and audit",
      "Separate bank account management",
      "RERA notice handling",
      "Project agreement vetting",
      "Carpet area certification",
      "RERA compliance advisory"
    ]
  },
  
  "project-finance": {
    title: "Project Finance & CMA Data",
    subtitle: "Comprehensive Project Financing Solutions",
    description: "Expert project finance services including CMA data preparation, feasibility reports, and loan assistance.",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&h=600&fit=crop",
    
    ourServices: [
      "CMA data preparation",
      "Project feasibility reports",
      "Financial projections and modeling",
      "Bank loan application support",
      "Working capital assessment",
      "Term loan documentation",
      "Subsidy and incentive applications",
      "Project appraisal support"
    ]
  },
  
  "audit-services": {
    title: "Audit & Assurance Services",
    subtitle: "Independent and Professional Audit Services",
    description: "Comprehensive audit services ensuring financial accuracy, compliance, and stakeholder confidence.",
    image: "https://images.unsplash.com/photo-1554224154-26032ffc0d07?w=1200&h=600&fit=crop",
    
    ourServices: [
      "Statutory audit (Companies Act)",
      "Tax audit (Income Tax Act)",
      "GST audit",
      "Internal audit",
      "Bank audit",
      "Concurrent audit",
      "Stock audit",
      "Management audit"
    ]
  }
};
